/** Client-safe metadata access for EN service pillars. */
import { EN_SERVICE_META, type EnServiceMeta } from "./meta.gen";

export const EN_SERVICES_META: EnServiceMeta[] = EN_SERVICE_META;

export function getEnServiceMeta(slug: string): EnServiceMeta | undefined {
  return EN_SERVICE_META.find((s) => s.slug === slug);
}

export function getEnSlugForThaiSlug(thaiSlug: string): string | undefined {
  return EN_SERVICE_META.find((s) => s.thaiSlug === thaiSlug)?.slug;
}

export type { EnServiceMeta };
